import get from 'lodash/get'
import has from 'lodash/has'
import isEmpty from 'lodash/isEmpty'

import { isRailBookers } from '../../configuration/brand'

/**
 * YLG400-401 - Client request to set the default sort order to newest
 * on all destination pages. This function assumes that a destination
 * page contains destinations filters for Amtrak or regions filters for
 * Railbookers.
 * @param {object} filters 
 * @returns boolean
 */
export const getIsDestinationPage = filters => {
  const destinationField = isRailBookers() ? 'regions' : 'destinations'
  const hasDestinationPageFilters = has(filters, destinationField, [])
  const destinationPageFilters = get(filters, destinationField, [])

  return hasDestinationPageFilters && !isEmpty(destinationPageFilters)
}
